import { useEffect } from 'react';

import { Appearance } from 'react-native';

import { EAppThemeMode, EAppThemeScheme, appThemeService, getSystemColorMode } from '@aqx-core/common/theme';
import { appThemeViewController } from '@aqx-core/common/theme/service/controller';
import { checkIsNative } from '@aqx-core/common/validators';

export const useInitColorTheme = () => {
  useEffect(() => {
    appThemeViewController.init(getSystemColorMode());
  }, []);

  useEffect(() => {
    // For mobile
    if (checkIsNative()) {
      const subscription = Appearance.addChangeListener(({ colorScheme }) => {
        const newColorScheme = colorScheme === 'dark' ? EAppThemeMode.DARK : EAppThemeMode.LIGHT;
        appThemeViewController.setDeviceThemeMode(newColorScheme);
        if (appThemeService.getThemeScheme() === EAppThemeScheme.SYSTEM_SCHEME) {
          appThemeViewController.updateTheme(EAppThemeScheme.SYSTEM_SCHEME, newColorScheme);
        }
      });
      return () => subscription.remove();
    } else {
      // For Web
      const eventObserver = window.matchMedia('(prefers-color-scheme: dark)');
      const preferenceChangeEvent = (e: MediaQueryListEvent) => {
        const newColorScheme = e.matches ? EAppThemeMode.DARK : EAppThemeMode.LIGHT;
        appThemeViewController.setDeviceThemeMode(newColorScheme);
        if (appThemeService.getThemeScheme() === EAppThemeScheme.SYSTEM_SCHEME) {
          appThemeViewController.updateTheme(EAppThemeScheme.SYSTEM_SCHEME, newColorScheme);
        }
      };
      eventObserver.addEventListener('change', preferenceChangeEvent);
      return () => eventObserver.removeEventListener('change', preferenceChangeEvent);
    }
  }, []);
};
